/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { FormHelperTextProps, InputLabelProps } from "@mui/material";
import InputContainerProps from "./InputContainerProps";

export default class InputContainerModel {
    public constructor(private readonly _props: InputContainerProps) { }

    public getFormControlClassNames(error: boolean): string {
        const propsClassName = this._props.formControlClassName ?? "";
        const formControlClass = `lan-inputcontainer__formcontrol`;
        return `${formControlClass} ${propsClassName}`;
    }

    public get formHelperTextProps(): FormHelperTextProps {
        const formHelperTextClassName = this._props.formHelperTextProps?.className ?? "";
        const formHelperMargin = this._props.formHelperTextProps?.margin ?? (this._props.margin === "dense")? "dense" : undefined;
        return { ...this._props.formHelperTextProps, className: `lan-inputcontainer__formhelpertext ${formHelperTextClassName}`, margin: formHelperMargin };
    }

    public getInputLabelProps(error: boolean): InputLabelProps {
        const className = `lan-inputcontainer__inputlabel ${error ? "lan-inputcontainer__inputlabel--error" : ""}`
        const inputLabelClassName = this._props.inputLabelProps?.className ?? "";
        return { ...this._props.inputLabelProps, className: `${className} ${inputLabelClassName}` };
    }
}